export default {
  mapCenter: { lat: 40.8519828, lng: -89.5927631 },
  breakpoints: {
    xs: 360,
    sm: 414,
    md: 768,
    mdl: 890,
    lg: 1280,
    xl: 1440,
    xxl: 1680,
  },
  /* This will return all focusable items inside the object you pass in. */
  focusable: (obj, excludeNonFocusableAttr) => {
    const nodeList = obj.querySelectorAll(
      'a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]'
    )

    return Array.from(nodeList).filter(elem => {
      return excludeNonFocusableAttr
        ? !elem.matches('[tabindex="-1"]') && !elem.matches('[disabled]')
        : elem
    })
  },
}
